import { ChangeEvent, useEffect, useState } from "react";
import styled from "styled-components";
import { useAlbum } from "../../hooks/useAlbum";
import InputDefault from "./InputDefault";

interface IsInputWithModalClick {
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSelectValue: (value: string) => void;
  onResetInput: () => void;
  vocalList: string[];
}

export default function InputWithModalClick({
  name,
  value,
  onChange,
  onSelectValue,
  onResetInput,
  vocalList,
}: IsInputWithModalClick) {
  const [isViewd, setIsViewd] = useState(false);
  const { searchValue, searchByVocal, resetSearchValue, searchFilter } =
    useAlbum();

  useEffect(() => {
    if (value !== "") {
      setIsViewd(true);
    } else if (value === "") {
      setIsViewd(false);
    }
  }, [value]);

  const onSelect = async (name: string) => {
    searchByVocal(value);
    await onSelectValue(name);
    setIsViewd(false);
  };

  const onRemoveSearchValue = () => {
    resetSearchValue();
    onResetInput();
  };

  const onFocusOut = () => {
    setIsViewd(false);
    (document.activeElement as HTMLElement).blur();
  };

  return (
    <InputWithModalStyle isViewd={isViewd}>
      <InputDefault
        name={name}
        value={value}
        onFocus={() => setIsViewd(true)}
        onChange={onChange}
        type={"text"}
        placeholder="Vocal"
      />
      <div className="Modal">
        {searchFilter(vocalList || [], value).map((e, i) => (
          <div key={i} onClick={() => onSelect(e)}>
            <p>{e}</p>
          </div>
        ))}
      </div>
      {isViewd && (
        <div
          className="OuterModal"
          onClick={() => setIsViewd(false)}
          onTouchMove={onFocusOut}
        ></div>
      )}
      {searchValue !== "" && (
        <div className="SearchValue" onClick={onRemoveSearchValue}>
          <p>{searchValue}</p>
        </div>
      )}
    </InputWithModalStyle>
  );
}

const InputWithModalStyle = styled.div<{ isViewd: boolean }>`
  position: relative;
  .Modal {
    position: absolute;
    width: 100%;
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    display: ${({ isViewd }) => (isViewd ? "flex" : "none")};
    flex-direction: column;
    top: 50px;
    border-width: 0px 1px 1px 1px;
    border-style: solid;
    border-color: #314af3;
    background-color: white;
    z-index: 100;
    div {
      display: flex;
      align-items: center;
      width: 100%;
      min-height: 36px;
      padding: 6px 12px;
      background-color: white;
      &:hover {
        background-color: #ebebeb;
        left: -10px;
      }
      p {
        width: fit-content;
        font-family: gmarket-sans-medium;
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }
  // input까지 가려짐
  .OuterModal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
    overflow: hidden;
    /* background-color: black;
    opacity: 0.2; */
  }
  .SearchValue {
    position: absolute;
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
    top: -1px;
    padding: 4px 16px;
    background-color: white;
    z-index: 200;
    cursor: pointer;
    &:hover {
      p {
        text-decoration: underline;
      }
    }
    p {
      font-family: gmarket-sans-medium;
      font-size: 14px;
    }
  }
`;
